export const ROUTE_HOME = '/';
export const ROUTE_REQUESTS = '/requests';
export const ROUTE_SCHEDULE = '/program/:date';
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_HELP = '/help';
